import React from "react";
import { Grid } from "@mui/material";
import "./reportHistory.scss";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import { convertUTCtoLocalTimeZone } from "../../../../utils/helper";

const ReportHistory = (props) => {
  const dataBack = {
    title: "Back",
    route: -1,
  };
  return (
    <>
      <Grid container>
        <Grid item md={12} xs={12}>
          <div className="containerReportHistory">
            <h1 className="commonTitle">Report History</h1>

            <div className="report-info">
              <p>
                <strong>Report ID:</strong> {props?.reportData?.reportId}
              </p>
              <p>
                <strong>Inspection Name:</strong>{" "}
                {props?.reportData?.questionSetName}
              </p>
            </div>

            <div className="history">
              <div className="created-info">
                <h3 className="commonTitle">Created Information</h3>
                <p>
                  <strong>Inspected By:</strong>{" "}
                  {props?.reportData?.inspectionBy}
                </p>
                <p>
                  <strong>Created date:</strong>{" "}
                  {convertUTCtoLocalTimeZone(
                    props?.reportData?.inspectionUpdateLog[0]?.updatedOn,
                    true
                  )}
                </p>
              </div>

              <div className="modification-history">
                <h3 className="commonTitle">Modification History</h3>
                <ul>
                  {props?.reportData?.inspectionUpdateLog?.length > 1 ? (
                    props?.reportData?.inspectionUpdateLog
                      ?.slice(1) // skip index 0
                      .map((log, index) => (
                        <li className="modification" key={index + 1}>
                          <p>
                            <strong>Inspected By:</strong>{" "}
                            {log?.userName || "Unknown"}
                          </p>
                          <p>
                            <strong>Modified date:</strong>{" "}
                            {convertUTCtoLocalTimeZone(log?.updatedOn, true) ||
                              "N/A"}
                          </p>
                        </li>
                      ))
                  ) : (
                    <li className="no-data">
                      No modification history available
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          <Grid item md={12} className="hideinprint">
            <BackBtn dataBack={dataBack} />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ReportHistory;
